import { render, staticRenderFns } from "./dust-db.component.vue?vue&type=template&id=40006ac6"
import script from "./dust-db.component.ts?vue&type=script&lang=ts&external"
export * from "./dust-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports